import { render, staticRenderFns } from "./QuestionType5.vue?vue&type=template&id=0eee6a8b&scoped=true"
import script from "./QuestionType5.vue?vue&type=script&lang=js"
export * from "./QuestionType5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eee6a8b",
  null
  
)

export default component.exports